import { render, staticRenderFns } from "./CommentRemoveModal.vue?vue&type=template&id=1153ec9d&"
import script from "./CommentRemoveModal.vue?vue&type=script&lang=js&"
export * from "./CommentRemoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports